import { apiErrorWithCode } from '@lib/api/utils/api-error-with-code';

/**
 * POST JSON to one of our API routes. Throws an ApiError carrying the real
 * status (so the global Clerk-401 refresh gate fires), the server message, the
 * parsed body, and the body's machine-readable `code` when it has one.
 * A 204 resolves to undefined, since there is no body to parse.
 */
export async function postJson<T>(url: string, body: unknown): Promise<T> {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw await apiErrorWithCode(res);
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}
